<div class="irembogov-template-configuration-header-widget">
  <header class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <span
        class="list-templates-back-button h5 me-2 mb-0 border-end align-self-center"
        placement="end"
        ngbTooltip="Back to Service Templates"
        (click)="goBackToTemplates()">
        <i class="fa-solid fa-angles-left me-2"></i>
      </span>
      <span class="me-2">
        <i aria-hidden="true" class="fas fa-layer-group"></i>
      </span>
      <span class="template-title"> Service Template Configuration </span>
    </div>

    <div *ngIf="template" class="text-center">
      <div>
        <span class="me-2 fw-semibold">{{ template.name }}</span>
        <span>
          <irembogov-service-template-status-badge [status]="template.status">
          </irembogov-service-template-status-badge>
        </span>
      </div>
      <p class="mb-0 text-muted small">
        {{ persistenceStatus }}
        <i
          *ngIf="persistenceStatus.includes('Saving') || isProcessing"
          class="fas fa-spinner fa-spin ms-1"></i>
      </p>
    </div>

    <div class="d-flex align-items-center gap-3">
      <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          id="templatePreviewSwitch"
          (change)="onPreviewToggle($event)"
          [disabled]="!template" />
        <label class="form-check-label" for="templatePreviewSwitch">
          Preview Form
        </label>
      </div>

      <div class="action-buttons d-flex gap-2">
        <button
          class="btn btn-outline-secondary save"
          (click)="OnSaveAndClose.emit()"
          [disabled]="isProcessing">
          <i class="fas fa-save me-2"></i>
          Save & Close
        </button>

        <button
          *ngIf="readyForPublish"
          class="btn btn-success"
          (click)="OnPublishTemplate.emit()"
          [disabled]="isProcessing">
          <i class="fas fa-upload me-2"></i>
          Publish Template
          <i *ngIf="isProcessing" class="fas fa-spinner fa-spin ms-2"></i>
        </button>
      </div>
    </div>
  </header>
</div>
